import API from './api';

class BrandsFilter {
    constructor({ node }) {
        this.$container = node;
        this.$navLink = this.$container.find('.js-brand');
        this.$brandsItems = this.$container.find('.js-brands');

        this.API = new API();
        this.init();
    }

    navLinkClickHandler = e => {
        e && e.preventDefault && e.preventDefault();
        const $this = $(e.currentTarget);

        $this.toggleClass('is-active');

        const text = $.makeArray(this.$navLink).reduce((acc, item) => {
            const $item = $(item);

            if ($item.hasClass('is-active')) {
                acc.push($item.text());
            }

            return acc;
        }, []).join('&brands=');

        const data = text ? 'brands=' + text : '';

        this.API.get({
            data,
            url: '/brands',
            loaderContainer: this.$brandsItems
        }).then(res => {
            if (res && res.html) {
                this.$brandsItems.html(res.html);
            }
        });
    };

    bindHandlers() {
        this.$navLink.on('click', this.navLinkClickHandler);
    }

    init() {
        this.bindHandlers();
    }
}

export default BrandsFilter;



// WEBPACK FOOTER //
// ./components/brandsFilter.js